import HttpClient from '../../core/services/http-client';
import { API_BASE_URL } from '../../cart/api/config';
import { BASE_API_CHECK_USER_BY_EMAIL, BASE_API_GET_USERNAME, BASE_API_LOGIN, BASE_API_REGISTER } from './config';

export const checkUserByEmail = (email) => HttpClient.execute(
    `${API_BASE_URL}${BASE_API_CHECK_USER_BY_EMAIL}`,
    'POST',
    {},
    { email },
);
export const loginWithEmail = (email, password) => HttpClient.execute(
    `${API_BASE_URL}${BASE_API_LOGIN}`,
    'POST',
    {},
    {
        username: email,
        password,
    },
);

export const register = (payload) => HttpClient.execute(
    `${API_BASE_URL}${BASE_API_REGISTER}`,
    'POST',
    {},
    payload,
);

export const fetchUsername = () => HttpClient.execute(`${API_BASE_URL}${BASE_API_GET_USERNAME}`, 'GET');
